/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { LIST_ITEM_CALL } from '@zcode-ui/web-zumper-integrations'
import { trackOptimizelyPhoneEvents } from '@zcode/nr/es/shared/thirdParty/optimizely/thunks'
import type { Listable } from '@zcode/state-type'
import { type MouseEvent, useCallback } from 'react'
import type { MixpanelOrigin } from '../../../../../../modules/mixpanel/helpers/getCommonProps'
import { mixpanelCall } from '../../../../../../modules/mixpanel/thunks/mixpanelCall'
import { trackListItemEvent } from '../../../../../../modules/traktor/thunks/trackListItemEvent'
import { useDispatch } from '../../../../../../modules/useDispatch'
import { trackCallEvent } from '../../../../../../utils/trackCallEvent'

interface Props {
  entity: Listable
  mixpanelOrigin: MixpanelOrigin
}

export function useOnPaidPhoneClick() {
  const dispatch = useDispatch()
  return useCallback(
    ({ entity, mixpanelOrigin }: Props) =>
      (e: MouseEvent<HTMLAnchorElement>) => {
        e.stopPropagation()

        trackCallEvent(entity)
        dispatch(trackListItemEvent({ name: LIST_ITEM_CALL, entity }))
        dispatch(trackOptimizelyPhoneEvents({ entity }))
        dispatch(mixpanelCall({ entity, origin: mixpanelOrigin }))
      },
    [dispatch]
  )
}
